/** Session-authenticated admin JSON (json-compat) — uses central HTTP + CSRF recovery. */

import { sessionFetch, HttpError } from './http';

export { HttpError };
export type { ErrorKind } from './http';

/**
 * Call an admin/session route and parse JSON.
 * Accepts a standard RequestInit (body may be JSON string or FormData).
 */
export async function adminJson<T>(path: string, init?: RequestInit): Promise<T> {
  const rawBody = init?.body;
  let body: unknown = undefined;
  if (rawBody instanceof FormData) {
    body = rawBody;
  } else if (typeof rawBody === 'string') {
    try {
      body = JSON.parse(rawBody);
    } catch {
      body = rawBody;
    }
  } else if (rawBody != null) {
    body = rawBody;
  }

  return sessionFetch<T>({
    url: path,
    method: init?.method ?? 'GET',
    headers: init?.headers,
    body,
    signal: init?.signal,
  });
}

export interface PageMeta {
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

export interface ListResponse<T> {
  data: T[];
  meta?: PageMeta;
}
